export const categories = [
  {
    id: 'yule',
    name: '娱乐',
    slug: 'yule',
    description: '影视、综艺、明星动态，最新娱乐资讯一网打尽',
    icon: 'ri-movie-2-line',
  },
  {
    id: 'zixun',
    name: '资讯',
    slug: 'zixun',
    description: '时事热点、社会新闻、科技前沿，掌握最新动态',
    icon: 'ri-newspaper-line',
  },
  {
    id: 'shenghuo',
    name: '生活',
    slug: 'shenghuo',
    description: '美食、旅行、健康、家居，发现生活之美',
    icon: 'ri-heart-pulse-line',
  },
  {
    id: 'keji',
    name: '科技',
    slug: 'keji',
    description: '数码产品、AI动态、互联网趋势，探索科技世界',
    icon: 'ri-cpu-line',
  },
  {
    id: 'tiyu',
    name: '体育',
    slug: 'tiyu',
    description: '赛事速递、球星动态、竞技分析，感受运动激情',
    icon: 'ri-basketball-line',
  },
  {
    id: 'shishang',
    name: '时尚',
    slug: 'shishang',
    description: '潮流穿搭、美妆护肤、品牌动态，引领时尚风潮',
    icon: 'ri-shirt-line',
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});